// extracted by mini-css-extract-plugin
module.exports = {"animationA":"videoAniA_animationA__G9Ux3"};